import { useQuery } from '@tanstack/react-query'
import { fetchContractorTrustScores, fetchContractorVendors } from '../../api/subs'

export interface SubVendorInfo {
  companyName: string
  /** Address-book vendors.id — null until email match (never vendor user id). */
  vendorId: number | null
  email?: string
}

/** Resolve address-book vendor + display name from trust vendor user id. */
export function useSubVendorInfo(vendorUserId: number, enabled: boolean) {
  return useQuery({
    queryKey: ['sub-vendor-info', vendorUserId],
    enabled,
    queryFn: async (): Promise<SubVendorInfo> => {
      const trustRows = await fetchContractorTrustScores()
      const trustRow = trustRows.find(r => Number(r.vendor_user_id) === vendorUserId)

      let vendorId: number | null = null
      let email = trustRow?.vendor_email ?? undefined
      let companyName = trustRow?.vendor_name?.trim() || ''

      try {
        const vendors = await fetchContractorVendors()
        const vendor = trustRow?.vendor_email
          ? vendors.find(v => v.email.toLowerCase() === trustRow.vendor_email!.toLowerCase())
          : undefined
        if (vendor) {
          vendorId = vendor.id
          email = vendor.email
          companyName = vendor.company_name?.trim() || companyName
        }
      } catch {
        /* address book optional — trust list still supplies display name */
      }

      return {
        companyName: companyName || `Vendor #${vendorUserId}`,
        vendorId,
        email,
      }
    },
  })
}
